import { Section, Option } from "../components/ui-components/AdvancedSelectInput/AdvancedSelectInput";
import ComponentsFile from "@json/components.json";
import SystemsFile from "@json/systems.json";
import { t } from "i18next";

export interface NorwegianStandard {
  id: string;
  name: string;
}
export class SystemsAndComponentsUtilities {
  static getAllSections() {
    return [...this.retrieveSectionsAndOptionsForComponents(), ...this.retrieveSectionsAndOptionsForSystems()];
  }
  static getAllOptions() {
    const sections = this.getAllSections();
    const options: Option[] = [];
    for (const section of sections) {
      for (const option of section.options) {
        options.push(option);
      }
    }
    return options;
  }

  static getAllSystemOptions() {
    const sections = this.retrieveSectionsAndOptionsForSystems();
    const options: Option[] = [];
    for (const section of sections) {
      for (const option of section.options) {
        options.push(option);
      }
    }
    return options;
  }

  static getOptionWithKey(standardID: any | undefined, key: string): Option | undefined {
    const sections = standardID === undefined ? this.getAllSections() : this.retrieveSections(standardID);
    for (const section of sections) {
      for (const option of section.options) {
        if (option.id === key) {
          return option;
        }
      }
    }
    return undefined;
  }

  static retrieveSections(standardID: any): Section[] {
    return typeof standardID === "string"
      ? standardID === "components"
        ? this.retrieveSectionsAndOptionsForComponents()
        : this.retrieveSectionsAndOptionsForSystems()
      : [];
  }

  static retrieveSectionsAndOptionsForComponents(): Section[] {
    const options: Option[] = ComponentsFile.components.map((fileRow) => {
      let id = fileRow.id.replace(/\s/g, "");
      let option: Option = {
        id: id,
        title: id + " " + (fileRow.name ?? ""),
        content: [],
      };
      for (let column in fileRow) {
        let body = (fileRow as any)[column]; // Fjern "as any" på ett eller annet vis
        if (column !== "id" && column !== "name") {
          option.content?.push({ title: column, body: body });
        }
      }
      return option;
    });
    const sections: Section[] = ComponentsFile.components_overview.map((fileRow) => {
      let id = fileRow.id.replace(/\s/g, "");
      let section: Section = {
        id: id,
        title: id + " " + (fileRow.name ?? ""),
        options: options.filter((option) => {
          return option.id[0].toLowerCase() === id.toLowerCase();
        }),
      };
      for (let column in fileRow) {
        let body = (fileRow as any)[column]; // Fjern "as any" på ett eller annet vis
        if (column !== "id" && column !== "name") {
          section.content?.push({ title: column, body: body });
        }
      }
      return section;
    });
    return sections;
  }

  static getStandards(): NorwegianStandard[] {
    return [
      { id: "systems", name: t("main.systems") },
      { id: "components", name: t("main.components") },
    ];
  }

  static retrieveSectionsAndOptionsForSystems(): Section[] {
    type systemInfo = { id: string; name?: string; guide?: string; comment?: string };

    // Filter out the category 1, because they are not systems
    const systems: systemInfo[] = SystemsFile.systems
      .filter((s) => !("" + s.id).startsWith("1"))
      .map((fileRow) => ({
        ...fileRow,
        id: fileRow.id + "",
      }));

    const infoKeys: (keyof systemInfo)[] = ["guide", "comment"];

    const options: Option[] = systems.map((fileRow) => {
      let id = fileRow.id.replace(/\s/g, "");
      let option: Option = {
        id: id,
        title: id + " " + (fileRow.name ?? ""),
        content: [],
      };
      for (let column of infoKeys) {
        let body = fileRow[column];
        if (body) option.content?.push({ title: column, body: body });
      }
      return option;
    });
    const sections: Section[] = systems
      .filter((s) => s.id.length == 2)
      .map((fileRow) => {
        let id = fileRow.id.replace(/\s/g, "");
        let section: Section = {
          id: id,
          title: id + " " + (fileRow.name ?? ""),
          options: options.filter((option) => {
            return option.id.startsWith(id);
          }),
        };

        for (let column of infoKeys) {
          let body = fileRow[column];
          if (body) section.content?.push({ title: column, body: body });
        }
        return section;
      });
    return sections;
  }
}
